import { DOCUMENT } from '@angular/common';
import { Component, OnInit, ElementRef, Inject, Renderer2 } from '@angular/core';
import { NSHelperService } from '../../../service/NSHelper.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidenav-list',
  templateUrl: './sidenav-list.component.html',
  styleUrls: ['./sidenav-list.component.scss']
})
export class SidenavListComponent implements OnInit {

  navList:any[] = [
    {routLink:'dashboard',caption:'ORDERMANAGEMENT.DASHBOARD'},
    {routLink:'customer-order',caption:'ORDERMANAGEMENT.MANAGE_ORDER'},
    {routLink:'selling-catalog',caption:'ORDERMANAGEMENT.SellingCatalogMenu'},
    {routLink:'manage-order',caption:'ORDERMANAGEMENT.ManageOrder'}

    // {routLink:'dashboard',listIcon:'assets/images/dashboard-icon.svg',listIconHover:'assets/images/dashboard-hover.svg',caption:'ORDERMANAGEMENT.DASHBOARD'},
    // {routLink:'customer-order',listIcon:'assets/images/client-icon.svg',listIconHover:'assets/images/client-hover.svg',caption:'ORDERMANAGEMENT.MANAGE_ORDER'},
    // {routLink:'selling-catalog',listIcon:'assets/images/client-icon.svg',listIconHover:'assets/images/client-hover.svg',caption:'ORDERMANAGEMENT.SellingCatalogMenu'},
    // {routLink:'manage-order',listIcon:'assets/images/client-icon.svg',listIconHover:'assets/images/client-hover.svg',caption:'ORDERMANAGEMENT.ManageOrder'}
  ];
  
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public elementRef: ElementRef,
    private renderer: Renderer2,
    private helper: NSHelperService,
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
  }
  mouseHover() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  sidebarMenuName:any;
  sideMenuName(name: any){
    this.sidebarMenuName = name;
    this.helper.sideMenuListName.next(this.sidebarMenuName);
  }

}
